import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('acquiflow_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('acquiflow_token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const analysesApi = {
  list: () => api.get('/analyses'),
  get: (id) => api.get(`/analyses/${id}`),
  create: (data) => api.post('/analyses', data),
  delete: (id) => api.delete(`/analyses/${id}`),
  updateData: (id, data) => api.put(`/analyses/${id}/data`, data),
  recalculate: (id) => api.post(`/analyses/${id}/calculate`),
  getAiInsights: (id) => api.post(`/analyses/${id}/ai-insights`),
  rename: (id, name) => api.put(`/analyses/${id}/rename`, { name }),
  duplicate: (id) => api.post(`/analyses/${id}/duplicate`),
  share: (id) => api.post(`/analyses/${id}/share`),
  getShared: (token) => api.get(`/shared/${token}`),
  updateStatus: (id, status) => api.post(`/analyses/${id}/status`, { status }),
  updateDealScoreWeights: (id, weights) => api.put(`/analyses/${id}/deal-score-weights`, { weights }),
  sensitivity: (id, swingPct = 0.20) => api.post(`/analyses/${id}/sensitivity`, { swing_pct: swingPct }),
  monteCarlo: (id, nSims = 1000) => api.post(`/analyses/${id}/monte-carlo`, { n_simulations: nSims }),
  compare: (ids) => api.post('/analyses/compare', { ids }),
  emailShare: (id, data) => api.post(`/analyses/${id}/email-share`, data),
  sectionPdf: (id, section) => api.post(`/analyses/${id}/section-pdf`, { section }),
  // Sharing with users
  shareWithUser: (id, userId, accessLevel) => api.post(`/analyses/${id}/share-with-user`, { user_id: userId, access_level: accessLevel }),
  unshareWithUser: (id, userId) => api.delete(`/analyses/${id}/share-with-user/${userId}`),
  getSharedUsers: (id) => api.get(`/analyses/${id}/shared-users`),
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/analyses/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default api;
